var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "email-selection-container",
      attrs: { id: "emailContainer" }
    },
    [
      _c("p", { staticClass: "breadcrumb" }, [
        _c("button", { on: { click: _vm.goBack } }, [_vm._v("< Back")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "header-container" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "product-container" }, [
          _c("div", { staticClass: "gift-container selected" }, [
            _c("img", {
              staticClass: "green-check",
              attrs: {
                src:
                  "https://cdn.shopify.com/s/files/1/1363/8433/files/check-circle.svg?v=1658433688"
              }
            }),
            _vm._v(" "),
            _c("img", {
              staticClass: "main-image lazyload",
              attrs: { src: _vm._f("getProductImage")(_vm.selectedCollection) }
            }),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.selectedCollection.title))])
          ])
        ]),
        _vm._v(" "),
        _vm._m(1)
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "main-container" }, [
        _c("div", { staticClass: "first-container" }, [
          _c("div", { staticClass: "directions-container" }, [
            _vm._m(2),
            _vm._v(" "),
            _c("ol", { staticClass: "desktop" }, [
              _vm._m(3),
              _vm._v(" "),
              _c("li", [
                _c("p", [
                  _vm._v("When complete, "),
                  _c("label", { attrs: { for: "file" } }, [
                    _c("img", {
                      attrs: {
                        src:
                          "https://cdn.shopify.com/s/files/1/1363/8433/files/upload_0c7b58b6-04e9-4bca-85b8-66b522cde950.svg?v=1732720359",
                        alt: "upload",
                        width: "20",
                        height: "20"
                      }
                    }),
                    _vm._v(" Upload your .csv")
                  ]),
                  _vm._v(
                    " the table below will populate with your information."
                  )
                ])
              ]),
              _vm._v(" "),
              _vm._m(4)
            ]),
            _vm._v(" "),
            _c("ol", { staticClass: "mobile" }, [
              _vm._m(5),
              _vm._v(" "),
              _c("li", [
                _c("p", [
                  _vm._v("When complete, "),
                  _c("label", { attrs: { for: "file" } }, [
                    _c("img", {
                      attrs: {
                        src:
                          "https://cdn.shopify.com/s/files/1/1363/8433/files/upload_0c7b58b6-04e9-4bca-85b8-66b522cde950.svg?v=1732720359",
                        alt: "upload",
                        width: "20",
                        height: "20"
                      }
                    }),
                    _vm._v(" Upload your .csv")
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm._m(6)
            ]),
            _vm._v(" "),
            _c("input", {
              staticClass: "file-uploader",
              attrs: { id: "file", type: "file" },
              on: { change: _vm.fileChange }
            })
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "recipients-container" },
          [
            _c("div", { staticClass: "qty-selection-container" }, [
              _vm._m(7),
              _vm._v(" "),
              _c("div", { staticClass: "content-container" }, [
                _c("div", { staticClass: "input-qty-container" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("Enter Number of Recipients")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.emailQty,
                        expression: "emailQty"
                      }
                    ],
                    attrs: { min: "1", type: "number" },
                    domProps: { value: _vm.emailQty },
                    on: {
                      change: _vm.validateQty,
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.emailQty = $event.target.value
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "checkbox-container" }, [
                  _c("label", { attrs: { for: "multiples" } }, [
                    _vm._v(
                      "I want different notification dates for my recipients"
                    )
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.multipleNotificationDate,
                        expression: "multipleNotificationDate"
                      }
                    ],
                    attrs: { id: "multiples", type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.multipleNotificationDate)
                        ? _vm._i(_vm.multipleNotificationDate, null) > -1
                        : _vm.multipleNotificationDate
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.multipleNotificationDate,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              (_vm.multipleNotificationDate = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.multipleNotificationDate = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.multipleNotificationDate = $$c
                        }
                      }
                    }
                  })
                ])
              ])
            ]),
            _vm._v(" "),
            _vm.showAlert
              ? _c("p", { staticClass: "red-alert" }, [
                  _vm._v(_vm._s(_vm.redAlertCopy))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.recipientList, function(recipient, i) {
              return _c(
                "div",
                {
                  key: i,
                  staticClass: "recipient",
                  class: [i % 2 == 0 ? "odd" : "even"]
                },
                [
                  _c("p", { staticClass: "recipient-title" }, [
                    _vm._v("Recipient " + _vm._s(i + 1) + ":")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "email-inputs-container" }, [
                    _c("div", { staticClass: "input-container" }, [
                      _c("p", [_vm._v("Email")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: recipient.email,
                            expression: "recipient.email"
                          }
                        ],
                        attrs: { placeholder: "Email address", type: "email" },
                        domProps: { value: recipient.email },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(recipient, "email", $event.target.value)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-container" }, [
                      _c("p", [_vm._v("First Name")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: recipient.firstName,
                            expression: "recipient.firstName"
                          }
                        ],
                        attrs: { placeholder: "First name", type: "string" },
                        domProps: { value: recipient.firstName },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              recipient,
                              "firstName",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-container" }, [
                      _c("p", [_vm._v("Last Name")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: recipient.lastName,
                            expression: "recipient.lastName"
                          }
                        ],
                        attrs: { placeholder: "Last name", type: "string" },
                        domProps: { value: recipient.lastName },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(recipient, "lastName", $event.target.value)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-container" }, [
                      _c("p", [_vm._v("From")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: recipient.from,
                            expression: "recipient.from"
                          }
                        ],
                        attrs: { placeholder: "Sender name", type: "string" },
                        domProps: { value: recipient.from },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(recipient, "from", $event.target.value)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _vm.multipleNotificationDate
                      ? _c(
                          "div",
                          { staticClass: "input-container" },
                          [
                            _c("p", [_vm._v("Notification Date")]),
                            _vm._v(" "),
                            _c("datepicker", {
                              attrs: {
                                format: _vm.formatDate,
                                disabledDates: _vm.disabledDates,
                                placeholder: "Notification Date"
                              },
                              model: {
                                value: recipient.notificationDate,
                                callback: function($$v) {
                                  _vm.$set(recipient, "notificationDate", $$v)
                                },
                                expression: "recipient.notificationDate"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "remove lazyload",
                    attrs: {
                      src:
                        "https://cdn.shopify.com/s/files/1/1363/8433/files/x_f565b23e-dc3f-4bd6-8843-442daa0e1434.svg?v=1719947652"
                    },
                    on: {
                      click: function($event) {
                        return _vm.removeRow(i)
                      }
                    }
                  })
                ]
              )
            })
          ],
          2
        ),
        _vm._v(" "),
        _c("p", { staticClass: "add", on: { click: _vm.addRecipient } }, [
          _vm._v("ADD RECIPIENT +")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "sticky-container" }, [
        !_vm.didSubmit && _vm.emailQty == 1
          ? _c(
              "button",
              {
                staticClass: "happybox-button green border",
                on: { click: _vm.submitEmailQty }
              },
              [
                _vm._v(
                  _vm._s(_vm.emailQty) +
                    " Recipients. Next: Enter Email Address"
                )
              ]
            )
          : !_vm.didSubmit && _vm.emailQty > 1
          ? _c(
              "button",
              {
                staticClass: "happybox-button green border",
                on: { click: _vm.submitEmailQty }
              },
              [
                _vm._v(
                  _vm._s(_vm.emailQty) +
                    " Recipients. Next: Enter Email Address"
                )
              ]
            )
          : _c(
              "button",
              {
                staticClass: "happybox-button green border",
                on: { click: _vm.nextStep }
              },
              [_vm._v("Next: Customize Your Email")]
            )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "copy-container mobile" }, [
      _c("p", { staticClass: "main-title" }, [
        _vm._v("Enter Recipient information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "copy-container" }, [
      _c("p", { staticClass: "main-title desktop" }, [
        _vm._v("Enter Recipient information")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "main-subtitle small" }, [
        _vm._v("Send just one or in bulk by uploading a spreadsheet.")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "directions-title" }, [
      _vm._v("Bulk Upload Recipients "),
      _c("img", {
        attrs: {
          alt: "bulk",
          src:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/bulk_icon_2df806c7-c557-455f-8022-c5d2d99b64a9.svg?v=1720467802"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("p", [
        _vm._v("First, "),
        _c(
          "a",
          {
            staticClass: "shipping-instructions",
            attrs: {
              href:
                "https://cdn.shopify.com/s/files/1/1363/8433/files/Happy_Box_GOC_Recipient_Email_Address_Template.xlsx?v=1683313367",
              download: "",
              target: "_blank"
            }
          },
          [
            _c("img", {
              attrs: {
                src:
                  "https://cdn.shopify.com/s/files/1/1363/8433/files/DOWNload.svg?v=1732720359",
                alt: "download",
                width: "20",
                height: "20"
              }
            }),
            _vm._v(" Download the template")
          ]
        ),
        _vm._v(" and fill it out")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("p", [_vm._v("Make any adjustments you might need below.")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("p", [
        _vm._v("First, "),
        _c(
          "a",
          {
            staticClass: "shipping-instructions",
            attrs: {
              href:
                "https://cdn.shopify.com/s/files/1/1363/8433/files/Happy_Box_GOC_Recipient_Email_Address_Template.xlsx?v=1683313367",
              download: "",
              target: "_blank"
            }
          },
          [
            _c("img", {
              attrs: {
                src:
                  "https://cdn.shopify.com/s/files/1/1363/8433/files/DOWNload.svg?v=1732720359",
                alt: "download",
                width: "20",
                height: "20"
              }
            }),
            _vm._v(" Download the template")
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("p", [
        _vm._v(
          "Your information will populate in the table below. Review and adjust as needed!"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "recipients-main-title" }, [
      _vm._v("Manually Upload Recipients"),
      _c("img", {
        attrs: {
          src:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/assitance.svg?v=1718205326"
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }